import { useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { Plus } from "lucide-react";
import { Reveal, Kicker } from "./Reveal";
import { CtaButton } from "./CtaButton";

const FAQ = [
  {
    q: "Czy dokumenty są zgodne z aktualnymi przepisami?",
    a: "Tak. Dokumenty przygotował prawnik specjalizujący się w branży gastronomicznej, a pakiet jest aktualizowany przy każdej istotnej zmianie przepisów. Kupując, zawsze pobierasz najnowszą wersję.",
  },
  {
    q: "Czy mogę je edytować pod swój lokal?",
    a: "Tak — pliki DOC są w pełni edytowalne. Miejsca do uzupełnienia (nazwa lokalu, dane firmy, godziny, stawki) są wyraźnie oznaczone, a wersja PDF służy jako wzór referencyjny.",
  },
  {
    q: "Jak szybko dostanę dokumenty po zakupie?",
    a: "Natychmiast. Po zaksięgowaniu płatności Stripe otrzymujesz link do pobrania na ekranie potwierdzenia oraz w wiadomości e-mail. Całość trwa zwykle mniej niż 2 minuty.",
  },
  {
    q: "Co jeśli mam pytania po zakupie?",
    a: "Napisz na adres podany w stopce — odpowiadam w ciągu 24 godzin roboczych. Pliki DOC są w pełni edytowalne, więc każdy dokument dopasujesz do swojego lokalu bez dodatkowych kosztów.",
  },
];

export const FaqSection = ({ onBuy }) => {
  const [open, setOpen] = useState(0);

  return (
    <section id="faq" data-testid="faq-section" className="bg-white px-6 py-24 sm:px-10 sm:py-32 lg:px-16">
      <div className="mx-auto max-w-3xl">
        <Reveal>
          <Kicker index="06" label="FAQ" />
          <h2 className="mt-6 font-display text-3xl font-semibold leading-tight tracking-tight sm:text-4xl lg:text-5xl">
            Pytania i odpowiedzi
          </h2>
        </Reveal>

        <Reveal delay={0.1} className="mt-12">
          <div data-testid="faq-accordion" className="border-t border-sand">
            {FAQ.map((item, i) => {
              const isOpen = open === i;
              return (
                <div key={item.q} data-testid={`faq-item-${i}`} className="border-b border-sand">
                  <button
                    data-testid={`faq-trigger-${i}`}
                    onClick={() => setOpen(isOpen ? -1 : i)}
                    aria-expanded={isOpen}
                    className="flex w-full items-center justify-between gap-6 py-6 text-left"
                  >
                    <span className="font-display text-lg font-semibold leading-snug sm:text-xl">
                      {item.q}
                    </span>
                    <Plus
                      className={`h-5 w-5 shrink-0 text-brick transition-transform duration-300 ${
                        isOpen ? "rotate-45" : ""
                      }`}
                    />
                  </button>
                  <AnimatePresence initial={false}>
                    {isOpen && (
                      <motion.div
                        key="content"
                        initial={{ height: 0, opacity: 0 }}
                        animate={{ height: "auto", opacity: 1 }}
                        exit={{ height: 0, opacity: 0 }}
                        transition={{ duration: 0.35, ease: [0.22, 1, 0.36, 1] }}
                        className="overflow-hidden"
                      >
                        <p
                          data-testid={`faq-answer-${i}`}
                          className="pb-7 pr-8 text-sm leading-relaxed text-clay sm:text-base"
                        >
                          {item.a}
                        </p>
                      </motion.div>
                    )}
                  </AnimatePresence>
                </div>
              );
            })}
          </div>
        </Reveal>

        <Reveal delay={0.15} className="mt-12 flex justify-center">
          <CtaButton onBuy={onBuy} testid="faq-cta-button" />
        </Reveal>
      </div>
    </section>
  );
};
